module.exports = __webpack_public_path__ + "img/implantacao.2c79b9b9.jpg";